import React from 'react';
import { InputClearButton } from '../InputClearButton';
import { Stack } from '../Stack';
import { jsx as _jsx } from "react/jsx-runtime";
export const SharedClearButton = _ref => {
  let {
    send,
    horizontalPosition,
    simple
  } = _ref;
  const handleClear = () => {
    send([{
      type: 'FOCUS'
    }, {
      type: 'CHANGE',
      value: undefined
    }, {
      type: 'COMMIT'
    }]);
  };
  return /*#__PURE__*/_jsx(Stack, {
    tokens: {
      padding: '5px 0px'
    },
    horizontalAlign: horizontalPosition !== null && horizontalPosition !== void 0 ? horizontalPosition : 'end',
    horizontal: true,
    children: /*#__PURE__*/_jsx(InputClearButton, {
      simple: simple,
      onClick: handleClear
    })
  });
};